import PurchaseSmsCreditModal from './PurchaseSmsCreditModal';

export default PurchaseSmsCreditModal;
